document.addEventListener('DOMContentLoaded', function () {
  var backBtn = document.querySelector('.cb-back');
  if (!backBtn) return;

  backBtn.addEventListener('click', function () {
    var referrer = document.referrer;
    var sameSite = referrer && referrer.indexOf(window.location.origin) === 0;
    var cameFromElsewhereOnSite = sameSite && referrer !== window.location.href;

    if (cameFromElsewhereOnSite && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = backBtn.dataset.fallback || '/collections/all';
    }
  });
});
